import React, { useState } from 'react';
import Card, { CardRow } from 'components/styleguide/card/Card';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import SearchInput, { Item } from 'components/styleguide/search_input/SearchInput';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

type Option = { label: string; value: number };

interface RoleCardProps {
  category_ids: number[];
  categories: Option[];
  url: string;
  required?: boolean;
}

const RoleCard: React.FC<RoleCardProps> = ({
  category_ids,
  categories,
  url: url,
  required = false,
}) => {
  const initialItems = categories.filter(c => (category_ids || []).includes(c.value));
  const [selectedItems, setSelectedItems] = useState<Item[]>(initialItems);
  const [pendingItems, setPendingItems] = useState<Item[]>([]);

  const sheet = useEditableSheet({
    url: url,
    payloadKey: 'talent',
    onSuccess: () => {
      setSelectedItems(pendingItems);
    },
  });

  const hasAny = selectedItems.length > 0;
  const tag = hasAny
    ? undefined
    : required
      ? { variant: 'error' as const, icon: 'circleAlert' as const, children: 'Mandatory' }
      : { variant: 'warning' as const, icon: 'circleAlert' as const, children: 'Missing' };

  const handleAddClick = () => {
    sheet.open('Add roles', {});
  };

  const handleEditClick = () => {
    setPendingItems(selectedItems);
    sheet.open('Edit roles', {
      category_ids: selectedItems.map(i => i.value),
    });
  };

  const handleRolesChange = (updated: Item[]) => {
    setPendingItems(updated);
    sheet.handleFormChange('category_ids', updated.map(i => i.value));
  };

  return (
    <>
      <Card
        title="Role(s)"
        iconName="codeXml"
        context="talent"
        tag={tag}
        onEdit={handleEditClick}
        onAdd={hasAny ? undefined : handleAddClick}
      >
        {hasAny && (
          <CardRow context="talent">
            <div className={styles.fieldGrid}>
              <div className={styles.field}>
                <p className={styles.value}>{selectedItems.map(i => i.label).join(', ')}</p>
              </div>
            </div>
          </CardRow>
        )}
      </Card>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="talent"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <SearchInput
            initialItems={selectedItems}
            options={categories}
            label="Roles"
            placeholder="Search roles..."
            required={true}
            error={sheet.getError('category_ids')}
            onChange={handleRolesChange}
          />
        </Sheet>
      )}
    </>
  );
};

export default RoleCard;
